import React from "react";
import { Header, HeaderWithSideMenu } from "@components/header/desktop";
import { DesktopLayoutProps } from "@data-types/layout/DesktopLayoutTypes";
import { HeaderType } from "@data-types/layout/headerTypeEnum";

export default function DesktopHeaderLayout(props: {
	headerType: DesktopLayoutProps["headerType"];
	headerActions: DesktopLayoutProps["headerActions"];
}) {
	switch (props.headerType) {
		case HeaderType.WITH_SIDEBAR:
			return (
				<HeaderWithSideMenu onNavTargetClick={props.headerActions} />
			);
		case HeaderType.EMPTY:
			return null;
		default:
			return <Header />;
	}
}
